import React from 'react';
import { Redirect } from 'react-router';

import {
	ORGANIZATION_CATALOG_TYPE_SINGLE,
	ORGANIZATION_CATALOG_TYPE_MULTI,
	ORGANIZATION_CATALOG_TYPE_PRIVATE,
} from '../../shared/constants/enums';
import loadable from '../../shared/utils/loadable';

// Code splitting!

const CatalogApp = loadable(() => import('../App'));

const CatalogHome = loadable(() => import('../containers/CatalogHome'));
const ProductDetails = loadable(() => import('../containers/ProductDetails'));

const getCatalogRoutes = (catalogType, isAdmin) => {

	if (catalogType === ORGANIZATION_CATALOG_TYPE_MULTI) {

		// For a multi product catalog (i.e. default behavior):

		// All users can see ALL product details pages
		// All users can see the catalog home page

		return [{
			// NOTE: Deprecated route
			path: '/catalog/track/:productSlug',
			component: ProductDetails,
		}, {
			// NOTE: Deprecated route
			path: '/catalog/course/:productSlug',
			component: ProductDetails,
		}, {
			path: '/catalog/:productSlug',
			component: ProductDetails,
		}, {
			path: '/',
			component: CatalogHome,
		}];

	}

	if (catalogType === ORGANIZATION_CATALOG_TYPE_SINGLE) {

		// For a single product catalog:

		// Non-admin users can only see details page for the default selected product
		// Admin users can see ALL product details pages
		// No users can see the catalog home page

		if (!isAdmin) {

			return [{
				path: '/',
				component: ProductDetails,
			}];

		}

		return [{
			// NOTE: Deprecated route
			path: '/catalog/track/:productSlug',
			component: ProductDetails,
		}, {
			// NOTE: Deprecated route
			path: '/catalog/course/:productSlug',
			component: ProductDetails,
		}, {
			path: '/catalog/:productSlug',
			component: ProductDetails,
		}, {
			path: '/',
			component: ProductDetails,
		}];

	}

	if (catalogType === ORGANIZATION_CATALOG_TYPE_PRIVATE) {

		// For a private product catalog:

		// Non-admin users will be auto-redirected to the dashboard
		// Admin users can see ALL product details pages
		// No users can see the catalog home page

		if (!isAdmin) {

			return [{
				path: '/',
				component: () => <Redirect to="/dashboard" />,
			}];

		}

		return [{
			// NOTE: Deprecated route
			path: '/catalog/track/:productSlug',
			component: ProductDetails,
		}, {
			// NOTE: Deprecated route
			path: '/catalog/course/:productSlug',
			component: ProductDetails,
		}, {
			path: '/catalog/:productSlug',
			component: ProductDetails,
		}, {
			path: '/',
			component: () => <Redirect to="/dashboard" />,
		}];

	}

	return [];

};

const routes = [{
	path: '/',
	component: CatalogApp,
	routes: [],
	getCatalogRoutes,
}];

export default routes;

